import {
  AutoComplete,
  Button,
  Checkbox,
  Collapse,
  message,
  Transfer,
  Input,
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { authUserData } from "../../utils/Helper";
import { debounce } from "lodash";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as FileImageOutlined } from "../../image/FileImageOutlined.svg";
// import { ReactComponent as SatyamevPhoto } from "../../image/SatyamevPhoto.svg";
// import { ReactComponent as AadharIcon } from "../../image/AadharIcon.svg";
import { DeleteOutlined } from "@ant-design/icons";
// import { deleteRequest } from "../../axios";
import { Breadcrumb, Col, Form, Row, Select, Space, Spin, Upload } from "antd";
import "antd/dist/antd.min.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../styles/Main.scss";
//import { dateSvg } from "../../image/date-svg.svg";
// import moment from "moment";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
// import { ReactComponent as LocationOutlined } from "../../image/LocationOutlined.svg";
// import { debounce } from "lodash";
// import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { LoadScript } from "@react-google-maps/api";
// import EmployeeImageUpload from "./EmployeeImageUpload";

// import EmployeeImageUpload from "./EmployeeImageUpload";
const { Option } = Select;

const AddEmployee = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const formRef = useRef();
  const { id } = useParams();
  const EmployeeId = id ? atob(id) : null;
  // const hasPermission = authUserData()?.role[0].name;
  const { Panel } = Collapse;
  const [sizepolicecheck, setSizepolicecheck] = useState(null);
  const [sizeuploaddrivinglicense, setsizeuploaddrivinglicense] =
    useState(null);
  const [fileLink, setFileLink] = useState(null);
  const [fileLinkpolice_check, setFileLinkpolice_check] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileNamepolice_check, setFileNamepolice_check] = useState(null);
  const [states, setStates] = useState([]);
  const [zones, setZones] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [postalList, setPostalList] = useState([]);

  const [postalInputValue, setPostalInputValue] = useState("");
  const [suburbInputValue, setSuburbInputValue] = useState("");
  const [zoneInputValue, setZoneInputValue] = useState("");

  const [zoneList, setZoneList] = useState([]);
  const [loadingZone, setLoadingZone] = useState(false);
  const [loadingPostal, setLoadingPostal] = useState(false);
  const [loadingSuburb, setLoadingSuburb] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [fileExists, setFileExists] = useState(false);
  // const [FileExistspan, setFileExistspan] = useState(false);
  // const [ErrorMessagepan, setErrorMessagepan] = useState(false);
  // const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  // const [cityDropdownOptions, setCityDropdownOptions] = useState([]);
  // const [stateDropdownOptions, setStateDropdownOptions] = useState([]);
  const [uploadFile, setUploadFile] = useState("");
  const [uploadFilepolicecheck, setUploadFilepolicecheck] = useState("");
  // const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  // const [postcodeList, setpostcodeList] = useState([]);
  // const [fileList, setFileList] = useState([]);
  // const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const initialState = {
    name: null,
    email: "",
    // address: "",
    street_address: null,
    additional_details: null,
    suburb: null,
    state: null,
    postcode: null,
    phone: "",
    company_name: "",
    work_on: "ABN 29122051171",
    abn_number: null,
    tax_file_number: null,
    account_holder_name: "",
    account_number: "",
    bank_name: "",
    branch_name: "",
    ifsc_code: "",
    emergency_contact_person_name: "",
    emergency_contact_person_no: "",
    visa_type: "Student Visa yes",
    state_filter: [],
    zone_filter: [],
    suburb_filter: [],
    postcode_filter: [],
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [mockData, setMockData] = useState([]);
  const [targetKeys, setTargetKeys] = useState(mockData);
  const [roleName, setRoleName] = useState([]);
  const [checked, setChecked] = useState(false);
  const [postalPage, setPostalPage] = useState(1);
  const [zonePage, setZonePage] = useState(1);
  const [suburbPage, setSuburbPage] = useState(1);
  const libraries = ["places"];

  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  //   libraries: ["places"],
  // });
    // Initial load
    useEffect(() => {
      if (state?.state_filter?.length) {
      fetchPostcodes(1, "");
      fetchSuburb(1,"");
      fetchZone(1,"");
    }
    }, [state?.state_filter]);
  useEffect(() => {
    setMockData(mockData);
  }, [mockData]);
  useEffect(() => {
   authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
  }, []);

  useEffect(() => {
    const normalizeZones = (zonesFromApi) =>
      zonesFromApi.map((z) => ({
        id: z.id,
        zone: z.zone || z.name, // support both shapes
        country_name: z.country_name || "Australia", // fallback if not given
        state_name: z.state_name || "",
      }));
      const normalizeSuburb = (suburbFromApi) =>
        suburbFromApi.map((z) => ({
          id: z.id,
          area: z.area || z.name, // support both shapes
          country_name: z.country_name || "Australia", // fallback if not given
          state_name: z.state_name || "",
          zone_name: z.zone_name || "",
        }));
        const normalizePostcode = (postcodeFromApi) =>
          postcodeFromApi.map((z) => ({
            id: z.id,
            pincode: z.pincode, // support both shapes
            country_name: z.country_name || "Australia", // fallback if not given
            state_name: z.state_name || "",
            zone_name: z.zone_name || "",
            suburb_name: z.suburb_name || "",
            customer_zone_name: z.customer_zone_name || "",
          }));
    const employeeGetById = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(`employee/${EmployeeId}/`);

        if (apiResponse.data.success) {
          // setFileLinkpolice_check(apiResponse.data.data.upload_police_check);
          // setFileLink(apiResponse.data.data.uploaddrivinglicense);

          const {
            id,
            status,
            user_data,
            // driving_license,
            // police_check,

            ...filteredResponse
          } = apiResponse.data.data;
        

           // normalize selected zones
    const selectedZones = normalizeZones(apiResponse.data.data.zone_filter || []);
    const selectedSuburb = normalizeSuburb(apiResponse.data.data.suburb_filter || []);
    const selectedPostcode = normalizePostcode(apiResponse.data.data.postcode_filter || []);
    // merge them into zoneList so Select can display correctly
    setZoneList((prev) => {
      const merged = [...prev];
      selectedZones.forEach((z) => {
        if (!merged.find((item) => item.id === z.id)) {
          merged.push(z);
        }
      });
      console.log("Merged",merged);
      return merged;
    });
    setSuburbList((prev) => {
      const merged = [...prev];
      selectedSuburb.forEach((z) => {
        if (!merged.find((item) => item.id === z.id)) {
          merged.push(z);
        }
      });
      console.log("Merged Suburb",merged);
      return merged;
    });
    setPostalList((prev) => {
      const merged = [...prev];
      selectedPostcode.forEach((z) => {
        if (!merged.find((item) => item.id === z.id)) {
          merged.push(z);
        }
      });
      console.log("Merged Postal",merged);
      return merged;
    });
          setState({
            // ...apiResponse.data.data,
            ...filteredResponse,
            // name: apiResponse.data.data.name,
            term_condition_accept: true,
            // role:,
            permission: apiResponse.data.data.permission.map((el) => el.id),
            state_filter: apiResponse.data.data?.state_filter?.map((res) => res.id) || [],
            zone_filter: apiResponse.data.data?.zone_filter?.map((res) => res.id) || [],
            suburb_filter: apiResponse.data.data?.suburb_filter?.map((res) => res.id) || [],
            postcode_filter: apiResponse.data.data?.postcode_filter?.map((res) => res.id),
            // name: apiResponse.data.data.name,
            // joining_date:
            //   apiResponse.data.data.joining_date === null
            //     ? null
            //     : moment(apiResponse.data.data.joining_date, "DD-MM-YYYY"),
            // resignation_date:
            //   apiResponse.data.data.resignation_date === null
            //     ? null
            //     : moment(apiResponse.data.data.resignation_date, "DD-MM-YYYY"),
            // reliving_date:
            //   apiResponse.data.data.reliving_date === null
            //     ? null
            //     : moment(apiResponse.data.data.reliving_date, "DD-MM-YYYY"),

            // senior_employee: apiResponse.data.data.senior_employee
            // .map(function (
            //   el
            // ) {
            //   return el.id;
            // }),
          });
          // getCityByState(apiResponse.data.data.state);
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            state: apiResponse?.data?.data?.state,
            suburb: apiResponse?.data?.data?.suburb,
            street_address: apiResponse?.data?.data?.street_address,
            postcode: apiResponse?.data?.data?.postcode,
            additional_details: apiResponse?.data?.data?.additional_details,
            // joining_date:
            //   apiResponse.data.data.joining_date === null
            //     ? null
            //     : moment(apiResponse.data.data.joining_date, "DD-MM-YYYY"),
            // resignation_date:
            //   apiResponse.data.data.resignation_date === null
            //     ? null
            //     : moment(apiResponse.data.data.resignation_date, "DD-MM-YYYY"),
            // reliving_date:
            //   apiResponse.data.data.reliving_date === null
            //     ? null
            //     : moment(apiResponse.data.data.reliving_date, "DD-MM-YYYY"),
            // employe_id: apiResponse.data.data.employe_id,

            name: apiResponse.data.data.name,
            state_filter: apiResponse.data.data?.state_filter?.map((res) => res.id) || [],
            zone_filter: apiResponse.data.data?.zone_filter?.map((res) => res.id) || [],
            suburb_filter: apiResponse.data.data?.suburb_filter?.map((res) => res.id) || [],
            
      //  suburb_filter:[     {
      //         "id": 12266,
      //         "area": "Wanneroo",
      //         // "state_name": "Western Australia",
      //         // "country_name": "Australia",
      //         // "zone_name": "PER1001"
      //     },
      //     {
      //         "id": 12265,
      //         "area": "Sinagra",
      //         // "state_name": "Western Australia",
      //         // "country_name": "Australia",
      //         // "zone_name": "PER1002"
      //     }
      //   ],
            postcode_filter: apiResponse.data.data?.postcode_filter?.map((res) => res.id),
            email: apiResponse.data.data.email,
            address: apiResponse.data.data.address,
            phone: String(apiResponse.data.data.phone),
            company_name: apiResponse.data.data.company_name,
            work_on: apiResponse.data.data.work_on,
            // police_check: apiResponse.data.data.police_check,
            // driving_license: apiResponse.data.data.driving_license,
            abn_number: apiResponse.data.data.abn_number,
            tax_file_number: apiResponse.data.data.tax_file_number,
            bank_detail: apiResponse.data.data.bank_detail,
            bank_account_no: apiResponse.data.data.bank_account_no,
            emergency_contact_person_name:
              apiResponse.data.data.emergency_contact_person_name,
            emergency_contact_person_no:
              apiResponse.data.data.emergency_contact_person_no,
            visa_type: apiResponse.data.data.visa_type,
            term_condition_accept: true,
            role: apiResponse.data.data.role_name,
            // pr_value_limit: apiResponse.data.data.pr_value_limit,
            // emergency_contact: apiResponse.data.data.emergency_contact,
            // address_line1: apiResponse.data.data.address_line1,
            // address_line2: apiResponse.data.data.address_line2,
            // category_tree: apiResponse.data.data.category_tree.map(function (
            //   el
            // ) {
            //   return el.id;
            // }),
            // senior_employee: apiResponse.data.data.senior_employee
            // .map(function (
            //   el
            // ) {
            //   return el.id;
            // }),
          });
          // setChecked( apiResponse?.data?.data?.term_condition_accept)

          setFileLink(apiResponse.data.data.driving_license);
          setFileLinkpolice_check(apiResponse.data.data.police_check);
          // try {
          //   filename = apiResponse.data.data.driving_license.split("/").pop();

          //   setFileName(filename);
          // } catch (e) {
          //   filename = "";
          //   setFileName(null);
          // }
          // try {
          //   filenamepolicecheck = apiResponse.data.data.police_check.split("/").pop();

          //   setFileNamepolice_check(filenamepolicecheck);
          // } catch (e) {
          //   filenamepolicecheck = "";
          //   setFileNamepolice_check(null);
          // }
          // const url = apiResponse.data.data.profile_photo;
          // setIdentifyProfileUrl(apiResponse.data.data.profile_photo);
          // if (url !== null) {
          //   setFileList([
          //     {
          //       // uid: '-1',
          //       // name: 'image.png',
          //       // status: 'done',
          //       url: url,
          //     },
          //   ]);
          // }
          // setUploadFileProfilePic(uploadedFile);
          // setFileNameProfilePic(uploadedFile.name); // Optionally, set file name
          setChecked(true);

          setTargetKeys(
            apiResponse?.data?.data?.permission.map((item) => item.id)
          );

          // getPermissionByRole(apiResponse?.data?.data?.role);
          // setSameAsCurrentAddress(apiResponse.data.data.same_as_address);
          setapiloading(false);
        }
      } catch (error) {
        ErrorNotificationMsg(t("error_in_list_employee"));
        setapiloading(false);
      }
    };
    if (EmployeeId !== null) {
      employeeGetById();
    }
    // getCityByState();
    // getPermission();
    // getState();
    // getRoleName();
    // getSenior();
    // getCategoryTree();
    // if (hasPermission !== "Super Admin" && hasPermission !== "Vendor Admin") {
    // getSite();
    // getCurrency();
    getRoleName();
    getPermission();
    // }
  }, [EmployeeId, t]);
  // Fetch postcodes with pagination + search
  const fetchPostcodes = async (page = 1, search = "") => {
    try {
      setLoadingPostal(true);
      const stateListParam = state?.state_filter?.length
      ? state.state_filter.join(",")
      : "";
      const response = await getRequest(
        `pincode/?page=${page}&search=${search}&pagesize=10&state_list=${stateListParam}`
      );
  
      // API structure: { count, next, previous, results: { success, data: [...] } }
      const results = response?.data?.results?.data || [];
      const count = response?.data?.count || 0;
      const hasNext = !!response?.data?.next; // if next URL exists, more pages available
  
      if (page === 1) {
        setPostalList(results); // fresh search
      } else {
        setPostalList((prev) => [...prev, ...results]); // append
      }
  
      // Only increment page if there’s a next page
      if (hasNext) {
        setPostalPage(page + 1);
      } else {
        setPostalPage(null); // stop infinite scroll
      }
    } catch (error) {
      console.error("Error fetching postcodes:", error);
    } finally {
      setLoadingPostal(false);
    }
  };
  const fetchSuburb = async (page = 1, search = "") => {
    try {
      setLoadingSuburb(true);
      const stateListParam = state?.state_filter?.length
      ? state.state_filter.join(",")
      : "";
      const response = await getRequest(
        `suburb/?page=${page}&search=${search}&pagesize=10&state_list=${stateListParam}`
      );
  
      // API structure: { count, next, previous, results: { success, data: [...] } }
      const results = response?.data?.results?.data || [];
      const count = response?.data?.count || 0;
      const hasNext = !!response?.data?.next; // if next URL exists, more pages available
  
      if (page === 1) {
        setSuburbList(results); // fresh search
      } else {
        setSuburbList((prev) => [...prev, ...results]); // append
      }
  
      // Only increment page if there’s a next page
      if (hasNext) {
        setSuburbPage(page + 1);
      } else {
        setSuburbPage(null); // stop infinite scroll
      }
    } catch (error) {
      console.error("Error fetching suburb:", error);
    } finally {
      setLoadingSuburb(false);
    }
  };
  const fetchZone = async (page = 1, search = "") => {
    try {
      setLoadingZone(true);
      const stateListParam = state?.state_filter?.length
      ? state.state_filter.join(",")
      : "";
      const response = await getRequest(
        `zone/?page=${page}&search=${search}&page_size=10&state_list=${stateListParam}`
      );
  
      // API structure: { count, next, previous, results: { success, data: [...] } }
      const results = response?.data?.results?.data || [];
      const count = response?.data?.count || 0;
      const hasNext = !!response?.data?.next; // if next URL exists, more pages available
  console.log("results",results);
      if (page === 1) {
        setZoneList(results); // fresh search
      } else {
        setZoneList((prev) => [...prev, ...results]); // append
      }
  
      // Only increment page if there’s a next page
      if (hasNext) {
        setZonePage(page + 1);
      } else {
        setZonePage(null); // stop infinite scroll
      }
    } catch (error) {
      console.error("Error fetching zone:", error);
    } finally {
      setLoadingZone(false);
    }
  };


  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };
  // const getPermission = async () => {

  //     setapiloading(true);

  //      {
  //       if (permissionArray.data) {
  //         const formattedData = permissionArray.data.map((item) => ({
  //           key: item.id,
  //           title: item.name,
  //           // title: item.name,
  //           title: item.name.toLowerCase(),
  //         }));
  //         setMockData(formattedData);
  //       }
  //     }
  //   }

  const getPermission = async () => {
    try {
      setapiloading(true);
      // const permissionArray = await getRequest("list-permission/");
      const permissionArray = await getRequest("create-group-permissions/");

      if (permissionArray.data.success) {
        if (permissionArray.data.response) {
          const formattedData =
            permissionArray.data.response[0].permissions.map((item) => ({
              key: item.id,
              // title: item.permission,
              title: item.permission.toLowerCase(),
              // title: item.name,
            }));
          setMockData(formattedData);
        }
        setapiloading(false);
      }
    } catch (error) {
      setapiloading(false);
      ErrorNotificationMsg("Error fetching permissions");
    }
  };
  const handleChange = (newTargetKeys) => {
    setTargetKeys(newTargetKeys);
    setState({ ...state, permission: newTargetKeys });
  };
  const handleRoleSelectChangeRole = (value) => {
    getPermissionByRole(value);
    getPermission();
  };

  const getPermissionByRole = async (id) => {
    const permissionResponse = await getRequest(
      "create-group-permissions/" + id
    );

    setTargetKeys(
      permissionResponse.data.response.permissions.map((item) => item.id)
    );

    setState((prevState) => ({
      ...prevState,
      role: id,
      permission: permissionResponse.data.response.permissions.map(
        (item) => item.id
      ),
    }));
    // setState({
    //   ...state,

    //   role: id,
    //   permission: permissionResponse.data.response.permissions.map(
    //     (item) => item.id
    //   ),
    // });
  };

  // const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
  // const [categoryTree, setCategoryTree] = useState([]);
  // const [seniorEmployee, setSeniorEmployee] = useState([]);
  // const [siteEmployee, setSiteEmployee] = useState([]);
  // const [currencySymbol, setCurrencySymbol] = useState("₹");
  // const [value, setValue] = useState(null);
// Handle search locally
const debouncedPostalSearch = useCallback(
  debounce((val) => {
    fetchPostcodes(1, val); // reset to page 1
  }, 500),
  []
);
const debouncedSuburbSearch = useCallback(
  debounce((val) => {
    fetchSuburb(1, val); // reset to page 1
  }, 500),
  []
);
const debouncedZoneSearch = useCallback(
  debounce((val) => {
    fetchZone(1, val); // reset to page 1
  }, 500),
  []
);
const handlePostalSearch = (value) => {
  setPostalInputValue(value);
  debouncedPostalSearch(value);
};
const handleSuburbSearch = (value) => {
  setSuburbInputValue(value);
  debouncedSuburbSearch(value);
};
const handleZoneSearch = (value) => {
  setZoneInputValue(value);
  debouncedZoneSearch(value);
};

// Handle scroll (lazy load more items)


  const getRoleName = async (data) => {
    await getRequest("create-group-permissions/", data).then((response) => {
      setRoleName(response.data.response);
    });
  };

  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
    setState((prevState) => ({
      ...prevState,
      term_condition_accept: e.target.checked,
    }));
  };

  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state_filter: value,
      // zone_filter: [],
      // suburb_filter: [],
      // postcode_filter: [],
    }));
    formRef.current.setFieldsValue({
      zone_filter: undefined,
      // suburb: undefined,
      suburb_filter: undefined,
      postcode: undefined,
    });
    setSuburbList([]);
    setPostalList([]);
    setZoneList([]);
    // getzoneByState(value);
  };

  const handleZoneChange = (selectedZones) => {
    setState((prevState) => ({
      ...prevState,
      zone_filter: selectedZones,
    })); 
  };

  const handleSuburbChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      suburb_filter: value,
     
    }));
  };
  const handleDropdownScrollPostal = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      postalPage && // check if we still have a next page
      scrollHeight - scrollTop <= clientHeight + 10 &&
      !loadingPostal
    ) {
      fetchPostcodes(postalPage, postalInputValue);
    }
  };
  
  const handleDropdownScrollSuburb = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      suburbPage && // check if we still have a next page
      scrollHeight - scrollTop <= clientHeight + 10 &&
      !loadingSuburb
    ) {
      fetchSuburb(suburbPage, suburbInputValue);
    }
  };
  const handleDropdownScrollZone = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      zonePage && // check if we still have a next page
      scrollHeight - scrollTop <= clientHeight + 10 &&
      !loadingZone
    ) {
      fetchZone(zonePage, zoneInputValue);
    }
  };
  
  const handlePostalChange = (value) => {
    // Update your parent state
    setState((prevState) => ({
      ...prevState,
      postcode_filter: value,
    }));
  };

 
  const getzoneByState = async (stateIds) => {
    setLoadingZone(true);
    setLoadingPostal(true);
    setLoadingSuburb(true);
  
    try {
      const payload = { state_ids: stateIds }; // Prepare the payload with stateIds array
  
      // Call both APIs in parallel using Promise.all
      const [zoneResponse, postalResponse, suburbResponse] = await Promise.all([
        postRequest("zone/state-wise-zone-list/?page=1&search=&pagesize=10", payload),
        postRequest("pincode/state-wise-pincode-list/?page=1&search=&pagesize=10", payload),
        postRequest("suburb/state-wise-suburb-list/?page=1&search=&pagesize=10", payload),
      ]);
  
      // const [zoneResponse, suburbResponse] = await Promise.all([
      //   getRequest("zone/?no_pagination=true"),
      //   // getRequest("pincode/?no_pagination=true"),
      //   getRequest("suburb/?no_pagination=true"),
      // ]);
  
      // Handle the response for the zone data
      console.log("zoneResponse", zoneResponse);
      if (zoneResponse?.data?.results?.success) {
        // const zones = zoneResponse.data.data;
        setZoneList(zoneResponse?.data?.results?.data);
      //   setState((prev) => ({ ...prev, zone_filter: zones.map((z) => z.id) }));
      // formRef.current.setFieldsValue({
      //   zone_filter: zones.map((z) => z.id),
      // });
      }
  
      // Handle the response for the postal data
      if (postalResponse?.data?.results?.success) {
        setPostalList(postalResponse?.data?.results?.data);
        // Calculate next page from API response
  const hasNext = !!postalResponse.data.next;
  setPostalPage(hasNext ? 2 : null); 
      }
  
      // Handle the response for the suburb data
      console.log("suburbResponse", suburbResponse);
      if (suburbResponse?.data?.results?.success) {
        // const suburbs = suburbResponse.data.data;
        setSuburbList(suburbResponse?.data?.results?.data);
        // setState((prev) => ({ ...prev, suburb_filter: suburbs.map((s) => s.id) }));
        // formRef.current.setFieldsValue({
        //   suburb_filter: suburbs.map((s) => s.id),
        // });
      }
  
      setLoadingZone(false);
      setLoadingPostal(false);
      setLoadingSuburb(false);
    } catch (error) {
      ErrorNotificationMsg(t("Error fetching zone, postal or suburb data"));
      setLoadingZone(false);
      setLoadingPostal(false);
      setLoadingSuburb(false);
    }
  };
  // const getzoneByState = async (id) => {
  //   const zoneResponse = await getRequest(
  //     "zone/?no_pagination=true&state_id=" + id
  //   );

  //   setZones(zoneResponse?.data?.data);
  // };

  // const handlepostcodeChange = async (postcode) => {
  //   if (postcode.length === 6) {
  //     try {
  //       const response = await getRequest(
  //         `postcode/?search_postcode_number=${postcode}`
  //       );

  //       if (response.data.results.data.length > 0) {
  //         const { state_name, city_name, id } = response.data.results.data[0];
  //         setState((prevState) => ({
  //           ...prevState,
  //           state: state_name,
  //           city: city_name,
  //           postcode: id,
  //         }));
  //         formRef.current.setFieldsValue({
  //           state: state_name,
  //           city: city_name,
  //         });
  //       }
  //       // setApiLoading(false);
  //     } catch (error) {
  //       // setApiLoading(false);
  //       console.error("Error fetching state and city:", error);
  //     }
  //   }
  // };

  // const searchIN = async (value) => {
  //   const apiResponse = await getRequest(
  //     `postcode/?search_postcode_number=${value}`
  //   );

  //   if (apiResponse.data.results.success) {
  //     setpostcodeList(apiResponse.data.results.data);
  //   }
  // };

  // const handleStateChange = (values) => {

  //   // const updatedAssignSite = [...state.assgin_site]; // Copying the array to avoid mutating state directly
  //   // updatedAssignSite[0] = {
  //   //   ...updatedAssignSite[0],
  //   //   category_tree: values,
  //   //   material_type: null,
  //   // }; // Updating the category_tree field
  //   setState({ ...state, state: values, city: null }); // Updating the state with the new category_tree value
  //   setCityDropdownOptions([]);
  //   formRef.current.setFieldsValue({
  //     ...state,
  //     state: values,
  //     city: "",
  //   });
  //   // Fetch material types based on the selected category
  //   if (values !== null && values !== undefined) {
  //     // getCityByState(values); //1 0
  //   }
  // };

  const urls = state?.driving_license;
  // const urlone = state.document_url;

  let filenamelicense = "";
  // let filenameadhar = "";
  try {
    if (fileLink) {
      filenamelicense = urls.split("/").pop();
    }
  } catch (e) {
    filenamelicense = "";
  }

  const url = state?.police_check;

  let filenamepolice_check = "";
  try {
    if (fileLinkpolice_check) {
      filenamepolice_check = url.split("/").pop();
    }
  } catch (e) {
    filenamepolice_check = "";
  }
  // try {
  //   if (fileLinkOne) {
  //     filenameone = urlone.split("/").pop();
  //   }
  // } catch (e) {
  //   filenameone = "";
  // }
// Normalize employee zones into the same structure as zoneList


 

  // const beforeUpload = (file) => {
  //   const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  //   if (!isJpgOrPng) {
  //     // setErrorMsg("You can only upload JPG/PNG file!");
  //     message.error("You can only upload JPG/PNG file!");
  //     return Upload.LIST_IGNORE;
  //   }
  //   // setErrorMsg(""); // Clear error message if file type is correct
  //   return false; // Prevent automatic upload, will handle manually
  // };
  // const uploadPropslicense = {
  //   accept: ".jpg, .png, .jpeg",
  //   showUploadList: false,
  //   beforeUpload: (file) => {
  //     const isJpgOrPng =
  //       file.type === "image/jpeg" || file.type === "image/png";

  //     if (!isJpgOrPng) {
  //       message.error("You can only upload JPG/PNG file!");
  //       return Upload.LIST_IGNORE;
  //     } else {
  //       setsizeuploaddrivinglicense(file.size);
  //       if (file.size <= 2097152) {
  //         setUploadFile(file);
  //         setFileName(file.name);
  //         setFileLink(null);
  //         Form.setFieldsValue({ driving_license: file }); // Set form value
  //       } else {
  //         message.error("You can upload up to 2MB!");
  //       }
  //     }
  //     return false; // Prevent automatic upload
  //   },
  // };
  const uploadPropslicense = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE;
      } else {
        setsizeuploaddrivinglicense(file.size);
        if (file.size <= 2097152) {
          setUploadFile(file);
          setFileName(file.name);
          setFileLink(null);
          // Set form field value when a file is successfully uploaded
          formRef.current.setFieldsValue({ driving_license: file });
        } else {
          message.error("You can upload up to 2MB!");
        }
      }
      return false; // Prevent automatic upload
    },
  };

  const uploadPropspolicecheck = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    // beforeUpload: (file) => {
    //   if (file.size <= 2097152) {
    //     setSizeAadhar(file.size);
    //     setUploadFileAadhar(file);
    //     setFileNameadhar(file.name);
    //     setFileLinkadhar(null);
    //     return true;
    //   } else {
    //     alert("File size exceeds 2MB.");
    //     return Promise.reject();
    //   }
    // },
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        // setErrorMsg("You can only upload JPG/PNG file!");
        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE;
      } else {
        // setSize(file.size);
        setSizepolicecheck(file.size);
        if (file.size <= 2097152) {
          setUploadFilepolicecheck(file);
          setFileNamepolice_check(file.name);
          setFileLinkpolice_check(null);
          formRef.current.setFieldsValue({ police_check: file });
        } else {
          message.error("You can upload upto 2mb!");
          return Upload.LIST_IGNORE;
        }
        // setErrorMsg("");
      }
      // Clear error message if file type is correct
      return false;
    },
  };

  // const uploadPropsProfilePhoto = {
  //   accept: ".jpg, .png, .jpeg, .pdf",
  //  showUploadList: false,
  //  beforeUpload: (file) => {
  //    //setUploadFile(file);
  //   //  setUploadFileProfilePic(file);
  //    //setFileName(file.name);
  //   //  setFileNameProfilePic(file.name);
  //    return false;
  //  },
  // }

  const handleDelete = () => {
    setState((prevState) => ({
      ...prevState,
      driving_license: null,
    }));
    setUploadFile("");
    //setUploadFileAadhar("");
    setFileName(null);
    // setFileNameadhar(null);
    setsizeuploaddrivinglicense(null);
    formRef.current.setFieldsValue({ driving_license: null });
  };

  const handleDeletePolice = () => {
    setState((prevState) => ({
      ...prevState,
      police_check: null,
    }));
    //setUploadFile("");
    setUploadFilepolicecheck("");
    //setFileName(null);
    setFileNamepolice_check(null);
    setSizepolicecheck(null);
    formRef.current.setFieldsValue({ police_check: null });
  };

  const handleFileDelete = async () => {
    const apiResponse = await patchRequest(
      `employee/${EmployeeId}/driving-license-delete/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_deleted_success"));
      setFileLink(null);

      setFileName(null);

      setsizeuploaddrivinglicense(null);
      formRef.current.setFieldsValue({ driving_license: null });
    }
  };

  const handleFileDeletePoliceCheck = async () => {
    const apiResponse = await patchRequest(
      `employee/${EmployeeId}/police-check-delete/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_deleted_success"));

      setFileLinkpolice_check(null);
      // setFileExists(false);
      setFileNamepolice_check(null);
      setSizepolicecheck(null);
      formRef.current.setFieldsValue({ police_check: null });
    }
  };

  const handleRoleSelectChange = (value) => {
    // getPermissionByRole(value);
    setState({ ...state, work_on: value });
    // setState({ ...state, visa_type: value });
  };

  const handleResidentSelectChange = (value) => {
    // getPermissionByRole(value);
    // setState({ ...state, work_on: value });
    setState({ ...state, visa_type: value });
  };

  // const handleChange = (newTargetKeys) => {
  //   // setTargetKeys(newTargetKeys);
  //   setState({ ...state, permission: newTargetKeys });
  // };
  // const handleChangePr = (name, value) => {
  //   setState({ ...state, [name]: value });
  // };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const phoneValidLength = state.phone;
  // const emergencyNumberValidLength = state.emergency_contact;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 8) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error("Please enter valid phone."));
    }

    return Promise.resolve();
  };
  const duplicateAreas = suburbList
  ?.reduce((acc, suburb) => {
    acc[suburb.area] = (acc[suburb.area] || 0) + 1;
    return acc;
  }, {});
  //  const phoneValidLengthEmergency = state.emergency_contact_person_no;
  // const validatePhoneNumberEmergency = () => {
  //   if (
  //     (phoneValidLengthEmergency && phoneValidLengthEmergency.length < 8) ||
  //     phoneValidLengthEmergency === null ||
  //     phoneValidLengthEmergency === ""
  //   ) {
  //     return Promise.reject(new Error("Please enter valid phone."));
  //   }

  //   return Promise.resolve();
  // };
  // const handlepostcodeChange = (name, value) => {
  //   // If you have another state variable called 'selectedpostcodeId', set it to the corresponding 'id'
  //   const selectedOption = postcodeList.find(
  //     (option) => option.postcode_number === value
  //   );
  //   const selectedId = selectedOption ? selectedOption.id : null;

  //   setState({ ...state, [name]: selectedId });
  // };

  // const validateEmergencyNumber = () => {
  //   if (
  //     (emergencyNumberValidLength && emergencyNumberValidLength.length < 8) ||
  //     emergencyNumberValidLength === null ||
  //     emergencyNumberValidLength === ""
  //   ) {
  //     return Promise.reject(new Error("Please enter valid emergency number."));
  //   }

  //   return Promise.resolve();
  // };
  const handleSelect = (value) => {
    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setState((prevstate) => ({
            ...prevstate,
            street_address: place.formatted_address,
            suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postcode_filter")
              )?.long_name || "",
          }));
          form.setFieldsValue({
            street_address: place.formatted_address,
            suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postcode_filter")
              )?.long_name || "",
          });
        }
      });
    }
  };

  // const handleSearch = useCallback(
  //   debounce((value) => {
  //     // setLoading(true);

  //     const service = new window.google.maps.places.AutocompleteService();

  //     if (value !== "") {
  //       service.getPlacePredictions({ input: value }, (predictions, status) => {
  //         if (
  //           status === window.google.maps.places.PlacesServiceStatus.OK &&
  //           predictions
  //         ) {
  //           setOptions(
  //             predictions.map((prediction) => ({
  //               value: prediction.description,
  //               place_id: prediction.place_id,
  //             }))
  //           );
  //           //setLoading(false);
  //         } else {
  //           setOptions([]);
  //           //setLoading(false);
  //         }
  //       });
  //     } else {
  //       setOptions([]);
  //       //setLoading(false);
  //       setState((prevstate) => ({
  //         ...prevstate,
  //         street_address: "",
  //         suburb: "",
  //         state: "",
  //         postcode: "",
  //       }));
  //       form.setFieldsValue({
  //         street_address: "",
  //         suburb: "",
  //         state: "",
  //         postcode: "",
  //       });
  //     }
  //   }, 300),
  //   [setOptions, form]
  // );
  const handleSubmit = async () => {
    // const payload = {
    //   employe_id: state.employe_id,
    //   first_name: state.first_name,
    //   last_name: state.last_name,
    //   email: state.email,
    //   phone: state.phone,
    //   designation: state.designation,
    //   role: state.role,
    //   aadhar_card: state.aadhar_card,
    //   pancard: state.pancard,
    //   pr_value_limit: state.pr_value_limit,
    //   emergency_contact: state.emergency_contact,
    //   address_line1: state.address_line1,
    //   address_line2: state.address_line2,
    //   city: state.city,
    //   state: state.state,
    //   postcode: state.postcode,
    //   landmark: state.landmark,
    //   same_as_address: state.same_as_address,
    //   permission: state.permission,
    //   category_tree: state.category_tree,
    //   senior_employee: state.senior_employee,
    //   assign_site_employee: state.assign_site_employee,
    //   joining_date:
    //     state.joining_date === null
    //       ? null
    //       : moment(state.joining_date, "DD-MM-YYYY").format("DD-MM-YYYY"),

    //   resignation_date:
    //     state.resignation_date === null
    //       ? null
    //       : moment(state.resignation_date, "DD-MM-YYYY").format("DD-MM-YYYY"),
    //   reliving_date:
    //     state.reliving_date === null
    //       ? null
    //       : moment(state.reliving_date, "DD-MM-YYYY").format("DD-MM-YYYY"),
    // };
    const payload = {
      // employe_id: state.employe_id,
      name: state.name,
      email: state.email,
      street_address: state.street_address,
      additional_details: state.additional_details,
      suburb: state.suburb,
      state: state.state,
      postcode: state.postcode,
      // address: state.address,
      phone: state.phone,
      company_name: state.company_name,
      work_on: state.work_on ? state.work_on : "ABN 29122051171",
      abn_number: state.abn_number,
      tax_file_number: state.tax_file_number,
      account_holder_name: state.account_holder_name,
      account_number: state.account_number,
      bank_name: state.bank_name,
      branch_name: state.branch_name,
      ifsc_code: state.ifsc_code,
      emergency_contact_person_name: state.emergency_contact_person_name,
      emergency_contact_person_no: state.emergency_contact_person_no,
      visa_type: state.visa_type ? state.visa_type : "Student Visa yes",
      role: state?.role,
      permission: state?.permission,
      term_condition_accept: true,
      state_filter: state?.state_filter,
      zone_filter: state?.zone_filter,
      suburb_filter: state?.suburb_filter,
      postcode_filter: state?.postcode_filter,
      // role: "Employee",
      // driving_license: state.driving_license,
      // driving_license: state.driving_license,
      // police_check: state.police_check,
      // term_condition_accept: state.term_condition_accept,
    };
    try {
      setBtnLoading(true);
      let response;

      // let customerHeaders = {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // };
      const formData = new FormData();
      // formData.append("profile_photo", uploadFileProfilePic);

      // formData.append("passport", null);
      // formData.append("visa", null);
      formData.append("police_check", uploadFilepolicecheck);
      formData.append("driving_license", uploadFile);
      formData.append("form_data", JSON.stringify(payload));
      // try {
      //   setBtnLoading(true);
      //   let response;
      if (EmployeeId === null) {
        response = await postRequest("employee/", formData);
      } else {
        response = await patchRequest(`employee/${EmployeeId}/`, formData);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          EmployeeId === null
            ? t("employee_added_successfully")
            : t("employee_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        navigate("/employee");
      }
      // } catch (error) {
      //   ErrorNotificationMsg(
      //     EmployeeId === null
      //       ? t("error_in_adding_employee")
      //       : t("error_in_updating_employee")
      //   );
    } catch (error) {
      if (EmployeeId === null) {
        ErrorNotificationMsg(
          // sectorId === null ? t("error_in_adding_sector_name") : t("error_in_updating_sector_name")
          t("error_in_adding_employee")
        );
      }
      if (EmployeeId !== null && !error?.message) {
        ErrorNotificationMsg(
          // sectorId === null ? t("error_in_adding_sector_name") : t("error_in_updating_sector_name")
          t("error_in_updating_employee")
        );
      }

      setBtnLoading(false);
    }
  };

  // const handleCategoryChange = (values) => {
  //   setState({ ...state, category_tree: values });
  // };
  // const handleCategoryChange = (values) => {
  //   setState({ ...state, category_tree: values }); // Updating the state with the new category_tree value
  //   formRef.current.setFieldsValue({
  //     ...state,
  //     category_tree: values,
  //   });
  //   // Fetch material types based on the selected category
  // };
  // const handleSiteChange = (values) => {
  //   setState({ ...state, assign_site_employee: values });
  // };
  // const handleSeniorChange = (values) => {
  //   setState({ ...state, senior_employee: values });
  // };
  // const colors = ["#737373"];

  // const handleCityChange = (values) => {
  //   // const updatedAssignSite = [...state.assgin_site]; // Copying the array to avoid mutating state directly
  //   // updatedAssignSite[0] = { ...updatedAssignSite[0], material_type: values }; // Updating the category_tree field
  //   setState({ ...state, city: values }); // Updating the state with the new category_tree value
  // };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {EmployeeId ? <h3>Edit Employee</h3> : <h3>Add Employee</h3>}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/employee"> {t("pl_employee")}</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                {EmployeeId ? "Edit Employee" : "Add Employee"}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Spin spinning={apiLoading}>
            <Form
              onFinish={handleSubmit}
              autoComplete="off"
              ref={formRef}
              form={form}
            >
              <LoadScript
                googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                libraries={libraries}
              >
                <Collapse defaultActiveKey={["1", "2", "3", "4"]}>
                  <Panel header="1. Employee Personal Info" key="1">
                    <Row gutter={[18]}>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="name"
                          label={t("Name")}
                          placeholder={t("Enter Name")}
                          rules={t("val_name")}
                          value={state?.name}
                          // pattern={"^[a-zA-Z ]+$"}
                          // prefix={<Name />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      {/* <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <InputField
                        name="last_name"
                        label={t("label_lastName")}
                        placeholder={t("pl_lastName")}
                        pattern={"^[a-zA-Z ]+$"}
                        rules={t("val_name")}
                        value={state.last_name}
                        prefix={<Name />}
                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </Col> */}

                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <EmailField
                          name="email"
                          label={t("label_email")}
                          placeholder={t("pl_email_2")}
                          rules={t("val_email")}
                          value={state?.email}
                          // prefix={<Email />}
                          handleInputChange={handleInputChange}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="address"
                          label={
                            <span>
                              {t("label_Address")}
                              <Tooltip
                                placement="top"
                                title="Flat, House no., Building, Company, Apratment"
                              >
                                <CircleIcon style={{ marginLeft: "6px" }} />
                              </Tooltip>
                            </span>
                          }
                          // label={t("label_Address")}
                          placeholder={t("pl_address_2")}
                          rules={t("val_address_2")}
                          value={state?.address}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={100}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name="phone"
                          label={t("label_phoneNumber")}
                          placeholder={t("pl_contact_num")}
                          rules={[
                            {
                              required: true,
                              validator: validatePhoneNumber,
                              message: <Trans> {t("val_contact_num")}</Trans>,
                            },
                          ]}
                        >
                          <PhoneInput
                            // country={"in"}
                            country={"au"}
                            className="PhoneSection"
                            value={state?.phone}
                            onChange={(phone) =>
                              setState({ ...state, phone: phone })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="street_address"
                          label={t("Street Address")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("Search Address")}</Trans>,
                            },
                          ]}
                        >
                          <AutoComplete
                            id="street_address"
                            placeholder={t("Search Address")}
                            options={options}
                            // onSearch={handleSearch}
                            onSearch={(value) => {
                              const service =
                                new window.google.maps.places.AutocompleteService();
                              if (value !== "") {
                                service.getPlacePredictions(
                                  { input: value },
                                  (predictions, status) => {
                                    if (
                                      status ===
                                        window.google.maps.places
                                          .PlacesServiceStatus.OK &&
                                      predictions
                                    ) {
                                      setOptions(
                                        predictions.map((prediction) => ({
                                          value: prediction.description,
                                          place_id: prediction.place_id,
                                        }))
                                      );
                                    } else {
                                      setOptions([]);
                                    }
                                  }
                                );
                              } else {
                                setOptions([]);
                                setState((prevstate) => ({
                                  ...prevstate,
                                  street_address: "",
                                  suburb: "",
                                  state: "",
                                  postcode: "",
                                }));
                                form.setFieldsValue({
                                  street_address: "",
                                  suburb: "",
                                  state: "",
                                  postcode: "",
                                });
                              }
                            }}
                            onSelect={handleSelect}
                            value={state.street_address}
                            onChange={(value) => {
                              setState((prevstate) => ({
                                ...prevstate,
                                street_address: value,
                              }));
                              form?.setFieldsValue({
                                street_address: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="suburb"
                          label={t("pl_suburb")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_suburb")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_suburb")}
                            name="suburb"
                            value={state.suburb}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                suburb: value,
                              }));
                              form.setFieldsValue({
                                suburb: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="state"
                          label={t("pl_state")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_state")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_state")}
                            name="state"
                            value={state.state}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                state: value,
                              }));
                              form.setFieldsValue({
                                state: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="postcode"
                          label={t("pl_Postcode")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_Postcode")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("pl_enter_postcode")}
                            name="postcode"
                            value={state.postcode}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                postcode: value,
                              }));
                              form.setFieldsValue({
                                postcode: value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="additional_details"
                          label={t("additional_details")}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("pl_enter_additional_detail")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("enter_additional_details")}
                            name="additional_details"
                            value={state.additional_details}
                            onChange={(e) => {
                              const { value } = e.target;
                              setState((prevstate) => ({
                                ...prevstate,
                                additional_details: value,
                              }));
                              form.setFieldsValue({
                                additional_details: value,
                              });
                            }}
                            // Adjust the number of rows as needed
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="company_name"
                          label={t("label_company_name")}
                          placeholder={t("pl_company_client_name")}
                          // rules={t("val_company_name_2")}
                          value={state.company_name}
                          // pattern={"^[a-zA-Z ]+$"}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>

                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name="role_name"
                          label="Role"
                          value={state.role}
                          // prefix={<User />}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_role")}</Trans>,
                            },
                          ]}
                        >
                          <Select
                            showArrow
                            placeholder="Select Role"
                            onChange={(value) =>
                              handleRoleSelectChangeRole(value)
                            }
                          >
                            {roleName.map((item) => (
                              <Option key={item.id} value={item.group_id}>
                                {item.group_name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name="work_on"
                          label={t("label_Work_on")}
                          value={state?.work_on}
                          // prefix={<User />}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: <Trans>{t("val_label_Work_on")}</Trans>,
                          //   },
                          // ]}
                        >
                          <Select
                            showArrow
                            // mode="multiple"
                            placeholder={t("label_role")}
                            onChange={(value) => handleRoleSelectChange(value)}
                          >
                            <Option key="1" value="ABN 29122051171">
                              ABN 29122051171
                            </Option>
                            <Option key="2" value="TFN">
                              TFN
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="abn_number"
                          label={t("label_ABN_Number")}
                          placeholder={t("pl_abn_number")}
                          rules={t("val_abn_number_2")}
                          nonRequiredRules={t("val_abn_number_2")}
                          pattern={"^\\d{11}$"}
                          value={state.abn_number}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="tax_file_number"
                          label={t("label_tax_file_number")}
                          placeholder={t("pl_tax_file_number_2")}
                          // rules={t("val_tax_file_number_2")}
                          nonRequiredRules={t("val_tax_file_number_2")}
                          pattern={"^\\d{8,9}$"} // Pattern for 8 or 9 digits
                          value={state.tax_file_number}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>

                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="emergency_contact_person_name"
                          label={t("label_emergency_contact_person_name")}
                          placeholder={t("pl_emergency_contact_person_name")}
                          // rules={t("val_emergency_contact_person_name_2")}
                          value={state.emergency_contact_person_name}
                          pattern={"^[a-zA-Z ]+$"}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name="emergency_contact_person_no"
                          label={t("label_emergency_contact_person_no")}
                          placeholder={t("pl_emergency_contact_person_no_num")}
                          // rules={[
                          //   {
                          //     required: true,
                          //     validator: validatePhoneNumberEmergency,
                          //     message: <Trans> {t("val_emergency_contact_person_number_2")}</Trans>,
                          //   },
                          // ]}
                        >
                          <PhoneInput
                            // country={"in"}
                            country={"au"}
                            className="PhoneSection"
                            value={state?.emergency_contact_person_no}
                            onChange={(emergency_contact_person_no) =>
                              setState({
                                ...state,
                                emergency_contact_person_no:
                                  emergency_contact_person_no,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>

                  <Panel header="2. Bank Details" key="2">
                    <Row gutter={[10]}>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="account_holder_name"
                          label={t("label_bank_detail")}
                          placeholder={t("pl_account_holder_name")}
                          // rules={t("val_bank_detail_2")}
                          pattern={"^[a-zA-Z ]+$"}
                          value={state.account_holder_name}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="account_number"
                          label={t("label_bank_account_number")}
                          placeholder={t("pl_bank_account_no_2")}
                          // rules={t("val_bank_account_no_2")}
                          value={state.account_number}
                          pattern={"^[0-9]{8,12}$"}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="bank_name"
                          label={t("label_bank_name")}
                          placeholder={t("pl_bank_name")}
                          // rules={t("val_bank_name")}
                          // value={state.bank_name}
                          pattern={"^[a-zA-Z ]+$"}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={50}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="branch_name"
                          label={t("label_bank_branch")}
                          placeholder={t("pl_bank_branch")}
                          pattern={"^[a-zA-Z0-9\\s]+$"}
                          // rules={t("val_bank_branch")}
                          value={state.branch_name}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={50}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="ifsc_code"
                          label={t("label_ifsc_code")}
                          placeholder={t("pl_ifsc_code")}
                          // rules={t("val_ifsc_code")}
                          value={state.ifsc_code}
                          // pattern={"^[A-Z]{4}0[A-Z0-9]{6}$"}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={11}
                        />
                      </Col>
                    </Row>
                  </Panel>

                  <Panel header="3. Upload Document" key="3">
                    <Row gutter={[10]}>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="visa_type"
                          label={t("label_Visa_type")}
                          // prefix={<User />}
                          value={state.visa_type}

                          // rules={[
                          //   {
                          //     required: true,
                          //     message: <Trans>{t("val_label_Visa_type")}</Trans>,
                          //   },
                          // ]}
                        >
                          <Select
                            showArrow
                            placeholder={t("Permanent Resident")}
                            // prefix={<User />}
                            onChange={(value) =>
                              handleResidentSelectChange(value)
                            }
                          >
                            <Option key="1" value="Student Visa yes">
                              Student Visa yes
                            </Option>
                            <Option key="2" value="Dependent Visa">
                              Dependent Visa
                            </Option>
                            <Option key="3" value="Permanent Resident">
                              Permanent Resident
                            </Option>
                            <Option key="4" value="Citizen">
                              Citizen
                            </Option>
                            <Option key="5" value="Other">
                              Other
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          name="driving_license"
                          className="BrowsButtonSec"
                          label={t("label_driving_license")}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: <Trans>{t("pl_upload_driving_licence")}</Trans>,
                          //   },
                          // ]}
                        >
                          <Upload
                            className="BrowsButton"
                            {...uploadPropslicense}
                            name="driving_license"
                          >
                            <Button icon={<FileImageOutlined />}>
                              {t("pl_choose_document")}
                            </Button>
                            <div className="condition">
                              {" "}
                              <p
                                style={{
                                  color:
                                    sizeuploaddrivinglicense > 2097152
                                      ? "red"
                                      : "GrayText",
                                }}
                              >
                                {t("upload_fileSize")}{" "}
                                {t("upload_imagefileType")}
                              </p>
                            </div>
                          </Upload>
                          {sizeuploaddrivinglicense <= 2097152 && (
                            <>
                              <Space className="uploadedfile" size={[12, 16]}>
                                <a
                                  href={fileLink}
                                  className="link-color"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {fileLink ? filenamelicense : fileName}
                                  {/* {fileLink
                                  ? fileName
                                  : filenamelicense} */}
                                </a>
                                {fileLink && (
                                  <DeleteOutlined onClick={handleFileDelete} />
                                )}
                                {fileName && (
                                  <DeleteOutlined onClick={handleDelete} />
                                )}
                              </Space>
                            </>
                          )}
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          className="BrowsButtonSec"
                          label={t("label_police_check")}
                          name="police_check"
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: <Trans>{t("val_file")}</Trans>,
                          //   },
                          // ]}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: <Trans>{t("pl_upload_police_check")}</Trans>,
                          //   },
                          // ]}
                        >
                          <Upload
                            className="BrowsButton"
                            {...uploadPropspolicecheck}
                            name="police_check"
                          >
                            <Button icon={<FileImageOutlined />}>
                              {t("pl_choose_document")}
                            </Button>
                            <div className="condition">
                              {" "}
                              <p
                                style={{
                                  color:
                                    sizepolicecheck > 2097152
                                      ? "red"
                                      : "GrayText",
                                }}
                              >
                                {t("upload_fileSize")}{" "}
                                {t("upload_imagefileType")}
                              </p>
                            </div>
                          </Upload>

                          {sizepolicecheck <= 2097152 && (
                            <>
                              <Space className="uploadedfile" size={[12, 16]}>
                                <a
                                  href={fileLinkpolice_check}
                                  className="link-color"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {fileLinkpolice_check
                                    ? filenamepolice_check
                                    : fileNamepolice_check}
                                </a>
                                {fileLinkpolice_check && (
                                  <DeleteOutlined
                                    onClick={handleFileDeletePoliceCheck}
                                  />
                                )}
                                {fileNamepolice_check && (
                                  <DeleteOutlined
                                    onClick={handleDeletePolice}
                                  />
                                )}
                              </Space>
                            </>
                          )}
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                        <Form.Item
                          className="BrowsButtonSec"
                          label={t("label_term_condition_accept")}
                          name="term_condition_accept"
                          valuePropName="checked"
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("val_terms_and_conditions")}</Trans>
                              ),
                            },
                            () => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.reject(
                                    new Error(t("val_terms_and_conditions"))
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Checkbox
                            onChange={handleCheckboxChange}
                            checked={checked}
                            className="checklabeltxt"
                          >
                            <Link to="/terms-and-conditions">
                              {t("pl_read_term_and_condition")}
                            </Link>
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>
                  <Panel header="4. Package Address Filter" key="4">
                  <p style={{ marginBottom: 16, fontSize: 14, color: '#666' }}>
    Leave filters empty to display all states and their related packages in the package list.
  </p>
                    <Row gutter={[10]}>
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                          <Form.Item name="state_filter" label={t("pl_state")}>
                        <Select
                          name="state_filter"
                          label={t("pl_state")}
                          placeholder={"Select State"}
                          value={state.state_filter}
                          onChange={handleStateSelectChange}
                          showArrow
                            mode="multiple"
                          showSearch
                          optionFilterProp="children"
                        

                        >
                          {states.map((state) => (
                            <Option key={state.id} value={state.id}>
                              {state.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                   
                       <Form.Item name="zone_filter" label={t("pl_zone")}>
                                            {/* <Select
                                              name="zone_filter"
                                              label={t("pl_zone")}
                                              placeholder="Select Zone"
                                              onChange={handleZoneChange}
                                              value={state.zone_filter}
                                              showArrow
                                              optionFilterProp="children"
                                              mode="multiple"
                                              showSearch
                                            
                                              loading={loadingZone}
                                              disabled={loadingZone}
                                            
                                            >
                                              {zoneList?.map((item) => (
                                                <Option key={item.id} value={item.id}>
                                                  {item.zone}
                                                </Option>
                                              ))}
                                            </Select> */}
                                             <Select
        placeholder={t("pl_select_zone")}
        name="zone_filter"
        mode="multiple"
        showArrow
        onChange={handleZoneChange}
        showSearch
        value={state?.zone_filter}
        optionFilterProp="children"
        filterOption={false} // because we handle search via API
        onSearch={handleZoneSearch}
        searchValue={zoneInputValue}
        onPopupScroll={handleDropdownScrollZone}
        notFoundContent={
          loadingZone ? (
            <div style={{ textAlign: "center" }}>
              <Spin size="small" />
            </div>
          ) : zoneList.length === 0 ? (
            <div style={{ textAlign: "center", padding: "8px" }}>
              {t("No zone found")}
            </div>
          ) : null
        }
        loading={loadingZone}
        style={{ width: "100%" }}
      >
        {zoneList?.map((zone) => (
          <Option key={zone.id} value={zone.id}>
            {zone.zone}
          </Option>
        ))}
      </Select>
                                          </Form.Item>
                                          </Col>        
                                          <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                                          {/* <Form.Item name="suburb_filter" label={t("Suburb")}>
                                            <Select
                                              placeholder="Select Suburb"
                                              name="suburb_filter"
                                              value={state.suburb_filter}
                                              showArrow
                                              onChange={handleSuburbChange}
                                              mode="multiple"
                                              showSearch
                                              optionFilterProp="children"
                                              loading={loadingSuburb}
                                              disabled={loadingSuburb}
                                          
                                            >
                                              {suburbList?.map((suburb) => (
                                                <Option
                                                  key={suburb.id}
                                                  value={suburb.id}
                                                >
                                                  {suburb.area}
                                                </Option>
                                              ))}
                                            </Select>
                                          </Form.Item> */}
                                          <Form.Item name="suburb_filter" label={t("Suburb")}>
                                          <Select
        placeholder={t("pl_select_suburb")}
        name="suburb_filter"
        mode="multiple"
        showArrow
        onChange={handleSuburbChange}
        showSearch
        value={state?.suburb_filter}
        optionFilterProp="children"
        filterOption={false} // because we handle search via API
        onSearch={handleSuburbSearch}
        searchValue={suburbInputValue}
        onPopupScroll={handleDropdownScrollSuburb}
        notFoundContent={
          loadingSuburb ? (
            <div style={{ textAlign: "center" }}>
              <Spin size="small" />
            </div>
          ) : suburbList.length === 0 ? (
            <div style={{ textAlign: "center", padding: "8px" }}>
              {t("No suburb found")}
            </div>
          ) : null
        }
        loading={loadingSuburb}
        style={{ width: "100%" }}
      >
        {suburbList?.map((suburb) => {
      const isDuplicate = duplicateAreas[suburb.area] > 1;
      const label = isDuplicate
        ? `${suburb.area} - ${suburb.state_name}`
        : suburb.area;

      return (
        <Option key={suburb.id} value={suburb.id}>
          {label}
        </Option>
      );
    })}
      </Select>
</Form.Item>

                                          </Col>   
                                          <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={4}
                        xl={4}
                        className="TextFeild"
                      >
                                          {/* <Form.Item name="postcode_filter" label={t("pl_postal")}>
                                            <Select
                                              placeholder={t("pl_select_postal")}
                                              name="postcode_filter"
                                              value={state.postcode_filter}
                                              showArrow  
                                              onChange={handlePostalChange}
                                              mode="multiple"
                                              showSearch
                                              optionFilterProp="children"
                                            
                                              loading={loadingPostal}
                                              disabled={loadingPostal}
                                           
                                            >
                                              {postalList?.map((postal) => (
                                                <Option
                                                  key={postal.id}
                                                  value={postal.id}
                                                >
                                                  {postal.name}
                                                </Option>
                                              ))}
                                            </Select>
                                          </Form.Item> */}
                                           <Form.Item name="postcode_filter" label={t("pl_postal")}>
      <Select
        placeholder={t("pl_select_postal")}
        name="postcode_filter"
        mode="multiple"
        showArrow
        onChange={handlePostalChange}
        showSearch
        value={state?.postcode_filter}
        optionFilterProp="children"
        filterOption={false} // because we handle search via API
        onSearch={handlePostalSearch}
        searchValue={postalInputValue}
        onPopupScroll={handleDropdownScrollPostal}
        notFoundContent={
          loadingPostal ? (
            <div style={{ textAlign: "center" }}>
              <Spin size="small" />
            </div>
          ) : postalList.length === 0 ? (
            <div style={{ textAlign: "center", padding: "8px" }}>
              {t("No postal found")}
            </div>
          ) : null
        }
        loading={loadingPostal}
        style={{ width: "100%" }}
      >
        {postalList?.map((postal) => (
          <Option key={postal.id} value={postal.id}>
            {`${postal.pincode} - ${postal.suburb_name}`}
          </Option>
        ))}
      </Select>
    </Form.Item>
                                          </Col>  
                     
                    
                    </Row>
                  </Panel>
                  <Panel header="4. Additional Permission" key="4">
                    <>
                      <Col md={24} lg={24} className="PermissionSec">
                        <Form.Item
                          name="permission"
                          //label="Additional Permission"
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: <Trans>Please select permission</Trans>,
                          //   },
                          // ]}
                        >
                          <Spin spinning={apiLoading}>
                            <Transfer
                              dataSource={mockData}
                              showSearch
                              // listStyle={{
                              //   width: 250,
                              //   height: 300,
                              // }}
                              onChange={handleChange}
                              render={(item) => item.title}
                              targetKeys={targetKeys}
                            />
                          </Spin>
                        </Form.Item>
                      </Col>

                      {/* <Row gutter={[10]}>
                      <Tabs defaultActiveKey="1" tabPosition="left">
                        {tabData.map((tab) => (
                          <TabPane tab={tab.label} key={tab.tabKey} >
                            {tab.tabKey === "1" && renderTableContent()}
                           
                          </TabPane>
                        ))}
                      </Tabs>
                    </Row> */}
                    </>
                  </Panel>
                </Collapse>
              </LoadScript>
              <div className="FormFooter">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  htmlType="button"
                  size="medium"
                  label="Cancel"
                  onClick={() => navigate("/employee")}
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="submit"
                  label="Save"
                  onClick={() => handleSubmit()}
                  disabled={!checked || btnLoading}
                  loading={btnLoading}
                />
              </div>
            </Form>
          </Spin>
        </div>
      </section>
    </>
  );
};

export default AddEmployee;
